<template>
  <div class="side-bar" v-bind:class="[{ active: value }, { 'is-mobile': isMobile }]">
    <div class="side-bar__container">
      <div class="side-bar__reverse">
        <button
          v-if="isMobile"
          class="side-bar__collapse"
          type="button"
          :title="value ? 'Развернуть' : 'Свернуть'"
          v-bind:class="{ active: value }"
          v-on:click="$emit('input', !value)" />
        <div class="side-bar__body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mobileMixin from '@/mixins/mobileMixin';
/**
 * @description Компонент боковой панели.
 * @type {Vue}
 */
export default {
  name: 'SideBar',
  props: {
    value: { type: Boolean, default: false },
  },
  mixins: [
    mobileMixin,
  ],
};
</script>

<style scoped lang="scss">
.side {
  &-bar {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    box-shadow: var(--shadow-layer);
    overflow: hidden;
    position: relative;
    width: 250px;
    &.is-mobile {
      padding-bottom: 60px;
    }
    &.active {
      width: 50px;
      padding: 0;
    }
    &__container {
      display: flex;
      overflow-y: auto;
      overflow-x: clip;
      -webkit-overflow-scrolling: touch;
      direction: rtl;
      scrollbar-width: none;
    }
    &__reverse {
      direction: ltr;
    }
    &__collapse {
      display: flex;
      position: absolute;
      bottom: 25px;
      right: 24px;
      width: 24px;
      height: 24px;
      background-image: url("@/assets/img/collapse.svg");
      background-size: contain;
      background-repeat: no-repeat;
      z-index: 3;
      &:hover {
        background-image: url("@/assets/img/collapse-active.svg");
      }
      &.active {
        background-image: url("@/assets/img/collapse-active-reverse.svg");
      }
    }
  }
  &-absolute {
    background: white;
    overflow-y: auto;
    position: fixed !important;
    width: 100% !important;
    max-width: 640px;
    padding: 22px 27px;
    right: 0;
    top: 0;
    bottom: 0;
    box-shadow: var( --shadow-layer-right);
    clip-path: none;
    z-index: 2;
    .side-bar__collapse {
      display: none;
    }
    .side-bar__container {
      width: 100%;
    }
  }
}

@media screen and (orientation: landscape) and (min-width:480px) and (max-width: 900px) {
  .side-bar {
    padding-bottom: 10px;
    &__container,
    &__reverse {
      overflow-y: auto;
    }
  }
}
@media screen and (max-width: 960px) {
  .side {
    &-bar {
      &.active {
        width: 35px;
      }
      &__collapse {
        position: relative;
        display: none;
        align-items: center;
        margin: 5px 0 5px auto;
        bottom: inherit !important;
        right: 5px;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .side {
    &-bar {
      transition: flex var(--animate-duration);
      flex: 0;
      width: 100%;
      padding: 0;
      &.is-mobile {
        padding: 0;
      }
      &.active {
        width: 100%;
        flex: 1 0 100%;
      }
      &__container {
        width: 100%;
        overflow-x: hidden;
        direction: ltr;
      }
      &__collapse {
        display: none;
        &.active {
          display: flex;
          &:before {
            content: 'Свернуть';
            color: #0489e0;
            margin: 0 0 0 -75px;
          }
        }
      }
      &__reverse {
        direction: ltr;
      }
    }
  }
}
</style>
